'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: ', ';\n  margin-left: ', ';\n\n  @media(min-width: ', ') {\n    display: ', ';\n  }\n'], ['\n  display: ', ';\n  margin-left: ', ';\n\n  @media(min-width: ', ') {\n    display: ', ';\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-weight: 600;\n  line-height: 1.5rem;\n  font-size: 18px;\n  margin-top: 10px;\n'], ['\n  color: ', ';\n  font-weight: 600;\n  line-height: 1.5rem;\n  font-size: 18px;\n  margin-top: 10px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _config = require('../../../config.js');

var _svg = require('../../../svg');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject, function (props) {
  return props.$showOnMobile ? 'block' : 'none';
}, function (props) {
  return props.$hasImage ? '15px' : '0px';
}, _config.breakpoints.m, function (props) {
  return props.$showOnDesktop ? 'block' : 'none';
});

var Text = _styledComponents2.default.h2(_templateObject2, _config.colors.darkRed);

Text.displayName = 'Text';

var Title = function Title(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === undefined ? '' : _ref$label,
      _ref$showOnDesktop = _ref.showOnDesktop,
      showOnDesktop = _ref$showOnDesktop === undefined ? true : _ref$showOnDesktop,
      _ref$showOnMobile = _ref.showOnMobile,
      showOnMobile = _ref$showOnMobile === undefined ? true : _ref$showOnMobile,
      hasImage = _ref.hasImage;
  return _react2.default.createElement(
    Wrapper,
    {
      $showOnDesktop: showOnDesktop,
      $showOnMobile: showOnMobile,
      $hasImage: hasImage
    },
    _react2.default.createElement(_svg.YellowLineSVG, null),
    _react2.default.createElement(
      Text,
      null,
      label
    )
  );
};

Title.propTypes = {
  /** the text to serve as a title */
  label: _propTypes2.default.string,
  showOnDesktop: _propTypes2.default.bool,
  showOnMobile: _propTypes2.default.bool,
  hasImage: _propTypes2.default.bool
};

Title.displayName = 'Title';

exports.default = Title;
Title.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'Title',
  'props': {
    'label': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'the text to serve as a title'
    },
    'showOnDesktop': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': ''
    },
    'showOnMobile': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': ''
    },
    'hasImage': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': ''
    }
  }
};